export default "__VITE_ASSET__KGx$dL0r__"